/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SchoolTypeEnum {
    school_type_elementary_school = 1,
    school_type_special_school = 3,
    school_type_secondary_school = 2,
    school_type_academic_high_school = 4,
    school_type_vocational_school = 5,
    school_type_custom = 0,
}
